import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "nav.people": "People",
      "nav.items": "Items",
      "nav.timeline": "Timeline",
      "nav.network": "Network",
      "nav.home": "Home",

      // Common UI
      "common.loading": "Loading...",
      "common.error": "Error",
      "common.notFound": "Not Found",
      "common.back": "Back",
      "common.close": "Close",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.clear": "Clear",

      // Person Page
      "person.biography": "Biography",
      "person.lifespan": "Lifespan",
      "person.region": "Region",
      "person.connections": "Connections",
      "person.relatedItems": "Related Items",
      "person.familyTree": "Family Tree",
      "person.wikipedia": "Wikipedia",
      "person.years": "{{birthYear}} - {{deathYear}}",
      "person.yearsBirth": "Born {{birthYear}}",
      "person.yearsDeath": "Died {{deathYear}}",
      "person.yearsUnknown": "Dates unknown",

      // Item Page
      "item.description": "Description",
      "item.type": "Type",
      "item.provenance": "Provenance",
      "item.relatedPeople": "Related People",
      "item.relatedItems": "Related Items",
      "item.period": "Period",
      "item.wikipedia": "Wikipedia",

      // Item Types
      "itemType.tea_bowl": "Tea Bowl",
      "itemType.tea_scoop": "Tea Scoop",
      "itemType.flower_vase": "Flower Vase",
      "itemType.incense_container": "Incense Container",
      "itemType.water_jar": "Water Jar",
      "itemType.kettle": "Kettle",
      "itemType.scroll": "Scroll",
      "itemType.other": "Other",

      // Family Relationships
      "family.father": "Father",
      "family.mother": "Mother",
      "family.son": "Son",
      "family.daughter": "Daughter",
      "family.brother": "Brother",
      "family.sister": "Sister",
      "family.spouse": "Spouse",
      "family.ancestor": "Ancestor",
      "family.descendant": "Descendant",

      // Error Messages
      "error.personNotFound": "Person not found",
      "error.itemNotFound": "Item not found",
      "error.loadingFailed": "Failed to load data",
      "error.networkError": "Network error",

      // Search & Filter
      "search.placeholder": "Search people and items...",
      "search.noResults": "No results found",
      "filter.byType": "Filter by Type",
      "filter.byPeriod": "Filter by Period",
      "filter.all": "All",

      // Language Toggle
      "lang.switch": "日本語",
      "lang.current": "English"
    }
  },
  jp: {
    translation: {
      // Navigation
      "nav.people": "人物",
      "nav.items": "道具",
      "nav.timeline": "タイムライン",
      "nav.network": "ネットワーク",
      "nav.home": "ホーム",

      // Common UI
      "common.loading": "読み込み中...",
      "common.error": "エラー",
      "common.notFound": "見つかりません",
      "common.back": "戻る",
      "common.close": "閉じる",
      "common.search": "検索",
      "common.filter": "フィルター",
      "common.clear": "クリア",

      // Person Page
      "person.biography": "略歴",
      "person.lifespan": "生没年",
      "person.region": "地域",
      "person.connections": "つながり",
      "person.relatedItems": "関連する道具",
      "person.familyTree": "家系図",
      "person.wikipedia": "ウィキペディア",
      "person.years": "{{birthYear}} - {{deathYear}}",
      "person.yearsBirth": "{{birthYear}}年生",
      "person.yearsDeath": "{{deathYear}}年没",
      "person.yearsUnknown": "年代不詳",

      // Item Page
      "item.description": "説明",
      "item.type": "種類",
      "item.provenance": "来歴",
      "item.relatedPeople": "関連する人物",
      "item.relatedItems": "関連する道具",
      "item.period": "時代",
      "item.wikipedia": "ウィキペディア",

      // Item Types
      "itemType.tea_bowl": "茶碗",
      "itemType.tea_scoop": "茶杓",
      "itemType.flower_vase": "花入",
      "itemType.incense_container": "香合",
      "itemType.water_jar": "水指",
      "itemType.kettle": "釜",
      "itemType.scroll": "掛物",
      "itemType.other": "その他",

      // Family Relationships
      "family.father": "父",
      "family.mother": "母",
      "family.son": "息子",
      "family.daughter": "娘",
      "family.brother": "兄弟",
      "family.sister": "姉妹",
      "family.spouse": "配偶者",
      "family.ancestor": "祖先",
      "family.descendant": "子孫",

      // Error Messages
      "error.personNotFound": "人物が見つかりません",
      "error.itemNotFound": "道具が見つかりません",
      "error.loadingFailed": "データの読み込みに失敗しました",
      "error.networkError": "ネットワークエラー",

      // Search & Filter
      "search.placeholder": "人物と道具を検索...",
      "search.noResults": "結果が見つかりません",
      "filter.byType": "種類で絞り込み",
      "filter.byPeriod": "時代で絞り込み",
      "filter.all": "すべて",

      // Language Toggle
      "lang.switch": "English",
      "lang.current": "日本語"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'kojitsukai-language'
    }
  });

export default i18n;